import { appApi } from "../api/app"
import { ElLoading } from "element-plus"
let loadingInstance = null
export default {
  namespaced: true,
  state: {
    navList: null,
    navIndex: {},
    logoConfig: {},
  },
  mutations: {
    SET_NAV_LIST(state, data) {
      state.navList = data
      console.log(data)
    },
    SET_NAV_INDEX(state, data) {
      state.navIndex = data
    },
    SET_LOGO_CONFIG(state, data) {
      state.logoConfig = data
    },
  },
  actions: {

  }
}